<div fxFlex class="vrm-order-popup">
  <div fxFlex class="vrm-order-popup-container" fxLayout="column">
    <div class="mvr-popup-header" fxLayoutAlign="center center" vrm-bg-color>
      <span>{{ 'ORDERMVR.mvrOrder' | translate }}</span>
    </div>
    <div class="mvr-popup-duplicate-order-header" fxLayoutAlign="center center" *ngIf='showDupExpiryError'>
      <span>{{ 'ORDERMVR.recentMvrOrderDetected' | translate }}</span>
    </div>
    <div class="mvr-popup-content" fxLayout='column'>
      <div class='mvr-popup-driver-information' fxLayout="row">
        <div class="mvr-popup-driver-information-item">
          <div class='mvr-popup-title'>{{ 'GENERIC.driver' | translate | uppercase }}</div>
          <span class='mvr-popup-driver'>{{ dialogData.fullName }}</span>
        </div>
        <div class="mvr-popup-driver-information-item">
          <div class='mvr-popup-md-license'>
            <div class='mvr-popup-title'>{{ 'ORDERMVR.licenceNumber' | translate | uppercase }}</div>
            <div class='mvr-popup-license-info' *ngIf="hasLicenceNumber; else noLicenseNumber">
              {{ dialogData.mvrLicenseNumber | uppercase | truncateString: 20 }}
            </div>
          </div>
          <ng-template #noLicenseNumber>
            <div class='item-filtered'>{{ 'ORDERMVR.missingMvrLicense' | translate }}</div>
          </ng-template>
        </div>
        <div class="mvr-popup-driver-information-item">
          <div class='mvr-popup-md-license' *ngIf="dialogData.stateName">
            <div class='mvr-popup-title'>{{ 'ORDERMVR.licenseState' | translate | uppercase }}</div>
            <span class='mvr-popup-license-info'>
              {{ dialogData.stateName | titlecase | truncateString: 20 }}
            </span>
          </div>
        </div>
        <div class="mvr-popup-driver-information-item"></div>
      </div>

      <mat-divider class='mvr-popup-order-divider'></mat-divider>
      <!-- MVR Order form-->

      <form [formGroup]='mvrOrderForm'
            *ngIf="hasLicenceNumber; else unableToOrderMVR;"
            (submit)='submitMvrOrder()'
            fxLayout="column"
      >
        <div fxFlex='auto' class='mvr-popup-order-information'>
          <!-- Mvr Override section -->
          <div *ngIf='showDupExpiryError'>
            <div class='mvr-popup-title'>{{ 'ORDERMVR.recentMvrOrderDetails' | translate | uppercase }}</div>
            <div class='mvr-override-info'>
              <p>
                {{ 'ORDERMVR.driverWasLastCheckedOn' | translate }}
                <b>{{ dialogData.mvrOrderDate }}</b>
              </p>
              <div *ngIf="hasOrderFromCurrentDay">
                <p>
                  {{ 'ORDERMVR.weAreOnlyPermittedToOneMVRPerDay' | translate }}
                </p>
                <p>
                  {{ 'ORDERMVR.theEarliestReorderIs' | translate: {nextOrderDate: earliestNextOrderDate ?? ''} }}
                </p>
                <p class="mvr-popup-return-later-message">
                  {{ 'ORDERMVR.returnOnToReorder' | translate: {nextOrderDate: earliestNextOrderDate ?? ''} }}
                </p>
              </div>
              <div *ngIf="!hasOrderFromCurrentDay">
                <p>
                  {{ 'ORDERMVR.dupExpiryInfo' | translate: {expiryDays: cService.userProfile.companySettings.mvrDupExpiryDays ?? ''} }}
                </p>
                <p *ngIf="hasPermissionToOverride">{{ 'ORDERMVR.overrideReorderInfo' | translate }}</p>
                <p *ngIf="!hasPermissionToOverride" class="mvr-popup-contact-to-reorder">
                  {{ 'ORDERMVR.contactToReorder' | translate }}
                  <a
                    href='mailto:mvrrequests@edriving.com?subject=MVR Recheck Request - {{ cService.userProfile.company}}'
                  >
                    mvrrequests@edriving.com
                  </a>.
                </p>
              </div>
            </div>
            <div class='consent-override' *ngIf="hasPermissionToOverride && !hasOrderFromCurrentDay">
              <mat-checkbox
                formControlName='mvrOverride'
                color='primary'
                class='mvr-popup-order-option mvr-order-hint mvr-override-checkbox'
              >{{ 'ORDERMVR.overrideCheckboxLabel' | translate }}
              </mat-checkbox>
            </div>
          </div>
        </div>

        <div *ngIf="!hideForm">
          <div *ngIf="showStateOptions" class="mvr-popup-order-options-container">
            <div class='mvr-popup-title'>{{ 'ORDERMVR.driverProvidedMvr' | translate | uppercase }}</div>
            <div class='mvr-popup-note'>{{ 'ORDERMVR.stateOfferMultipleReports' | translate }}</div>
            <div class='mvr-popup-note'>
              <strong>{{ 'ORDERMVR.important' | translate }}:</strong>
              <span class='mvr-popup-hint'>{{ 'ORDERMVR.unsureOfTypeReportHint' | translate }}</span>
            </div>

            <mat-radio-group class='mvr-popup-order-options' formControlName='mvrOrderOption'>
              <mat-radio-button
                *ngFor="let option of dialogData.mvrOrderOptions"
                class='mvr-popup-order-option'
                [value]='option.code'
              >
                {{ option.type }}
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <div class='mvr-popup-title'>
            {{ 'ORDERMVR.emailAlert' | translate | uppercase }}
          </div>

          <mat-form-field appearance='fill' class='mvr-popup-email-confirmation'>
            <mat-label>{{ 'ORDERMVR.emailConfirmation' | translate }}</mat-label>
            <mat-select formControlName='emailConfirmation'>
              <mat-option [value]='false'>
                {{ 'ORDERMVR.dontSendAlert' | translate }}
              </mat-option>
              <mat-option [value]='true'>
                {{ 'ORDERMVR.sendAlert' | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <br/>
          <mat-form-field appearance='fill' hintLabel='Max 50 characters' class='mvr-popup-email'>
            <mat-label>{{ 'FORM.emailAddress' | translate }}</mat-label>
            <input matInput #input maxlength='50' placeholder='Enter email here' formControlName='email'/>
            <mat-hint align='end'>{{ input.value?.length || 0 }}/50</mat-hint>
            <mat-error *ngIf='mvrOrderEmail.invalid'>{{ 'FORM.invalidEmail' | translate }}</mat-error>
          </mat-form-field>

          <!-- MVR Errors section -->
          <div class="mvr-popup-error-message-section">
            <div fxFlex='grow' *ngIf="!hasLicenceNumber">
              <p fxLayout='row' fxLayoutAlign='start center'>
                {{ 'MESSAGESANDWARNINGS.noValidDriverLicenseSuggestion' | translate }}
              </p>
            </div>
            <div fxFlex='grow' *ngIf='orderMvrRequestFailed'>
              <p fxLayout='row' fxLayoutAlign='start center'>
                {{ 'ORDERMVR.pleaseVerifyDriverHas' | translate }}:
              </p>
              <ul class='mvr-failed-suggestion-list'>
                <li>{{ 'MESSAGESANDWARNINGS.hasMvrInformationSuggestion' | translate }}</li>
                <li>{{ 'MESSAGESANDWARNINGS.pendingMvrOrderSuggestion' | translate }}</li>
              </ul>
            </div>
          </div>

          <div class='mvr-order-hint'>
            <b>{{ 'GENERIC.note' | translate }}:</b> {{ 'ORDERMVR.mvrAlertNote' | translate }}.
          </div>
          <div class="mvr-popup-order-button-container">
            <button
              mat-flat-button
              [disabled]='
                !mvrOrderForm.valid ||
                !isOrderMvrButtonActive ||
                (showDupExpiryError && mvrOrderForm.get("mvrOverride").value === false)
              '
              [class.mvr-order-btn-retry]='orderMvrRequestFailed'
              class='mvr-order-btn'
            >
              <span *ngIf="!orderMvrRequestFailed">{{ 'ORDERMVR.orderMvrNow' | translate | uppercase}}</span>
              <span *ngIf="orderMvrRequestFailed">{{ 'FORM.retry' | translate | uppercase }}</span>
            </button>
          </div>

          <div class='mvr-order-hint'>
            {{ 'ORDERMVR.mvrSubmitNote' | translate }}
            <b>{{ cService.userProfile.company | titlecase }}</b
            >.
          </div>
        </div>
      </form >

      <ng-template #unableToOrderMVR>
        <div class="mvr-unable-order">
          <div class="mvr-unable-order-title">
            {{ 'ORDERMVR.unableToOrderMVR' | translate | uppercase}}
          </div>
          <div class="mvr-unable-order-message">
            <p>
              {{ 'ORDERMVR.missingRequiredInformationToOrderMVR' | translate }}
            </p>
            <p>
              {{ 'ORDERMVR.reasonMissingRequiredInformation' | translate }}
            </p>
          </div>
          <div class="mvr-unable-order-further-info">
            <p>
              {{ 'ORDERMVR.pleaseContactForFurtherInformation' | translate }}
              <a href='mailto:mvrrequests@edriving.com'>mvrrequests@edriving.com</a>.
            </p>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
  <!-- Close-->
  <button type='button' class='popup-close' (click)='dialog.close()' vrm-bg-color>
    <mat-icon>close</mat-icon>
  </button>
</div>
